import {
  Service
} from './index'
// APPLET - [通用API] 小程序登录信息获取
export function mobile_message(data) {
  return Service({
    url: 'amall_user/user/appletLoginByMobile',
    method: "post",
    params: data
  })
}
//总后台-APPLET - [通用API] 省市级三级联动
export function getPositionList(data) {
  return Service({
    url: '/amall_user/user/getPCD',
    method: 'post',
    params: data
  })
}
//APPLET_WEB - [消息中心] 查询当前用户消息中心
export function messageList(data) {
  return Service({
    url: '/amall_user/message/findMessage',
    method: 'post',
    params: data
  })
}
//APPLET_WEB - [消息中心] 将当前用户的所有未读消息置位已读
export function allRead(data) {
  return Service({
    url: '/amall_user/message/updateMessageReadByLogin',
    method: 'post',
    params: data
  })
}
//APPLET_WEB - [消息中心] 根据消息ID设置该消息为已读
export function everRead(data) {
  return Service({
    url: '/amall_user/message/updateMessageRead',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}
//APPLET_WEB - [消息中心] 查询当前用户未读消息数量
export function allNoRead(data) {
  return Service({
    url: '/amall_user/message/findMessageNum',
    method: 'post',
    params: data
  })
}
//总后台 - [用户管理] 新增用户/业主
export function add_user(data) {
  return Service({
    url: '/amall_user/user/addUser',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/service/user_h.js